import { css } from "@emotion/react";

export const Flex = css`
  display: flex;
  align-items: center;
`;
